'use client'

import { classNames } from 'lib/generic-utils';
import Link, { LinkProps } from 'next/link';
import { PropsWithChildren } from 'react';


export function StyledLink({className, discrete, children, ...props} : PropsWithChildren<LinkProps> & {className?: string, discrete?: boolean}) {
  return (
    <Link className={classNames(className ?? '', discrete ? "text-black dark:text-white" : "text-blue-600 dark:text-blue-500", "underline hover:no-underline")} {...props}>
      {children}
    </Link>
  )
}